<template>
  <v-main class="tpadding">
    <div id="mapa">
      <gmap-map
        ref="gmap"
        :center="center"
        :zoom="zoom"
        style="width: 100%; height: 92vh"
        :options="option"
      >
        <div v-for="vehicle in vehicles" :key="vehicle.key">
          <gmap-marker
            v-if="vehicle.visible == true"
            :zoomOnClick="true"
            :position="vehicle.coor"
            :icon="rotateImageVehicle(vehicle.angule)"
            :draggable="false"
            v-on:mouseover="openWindow(vehicle)"
            v-on:mouseout="closeWindow(vehicle)"
          >
            <gmap-info-window :opened="vehicle.dialog">
              <div class="vehicleModal">
                <b>Número de unidad:</b>
                {{ vehicle.noVehicle }}
              </div>
              <div class="vehicleModal">
                <b>Tipo de servicio:</b>
                {{ vehicle.tipo_servicio }}
              </div>
              <div class="vehicleModal">
                <b>Turno:</b>
                {{ vehicle.turno_id }}
              </div>
            </gmap-info-window>
          </gmap-marker>
        </div>
        <div>
          <GmapCluster
            :ignoreHidden="false"
            :position="center"
            :zoomOnClick="true"
            :clickable="true"
            :animation="2"
          >
            <div v-for="marker in markers" :key="marker.key">
              <gmap-marker
                v-if="marker.visible == true"
                :position="marker.coor"
                :icon="icon"
                :draggable="false"
                v-on:mouseover="openWindow(marker)"
                v-on:mouseout="closeWindow(marker)"
              >
                <gmap-info-window :opened="marker.dialog">
                  <div class="dialog">
                    {{ marker.stopName }}
                  </div>
                  <div class="dialog">
                    {{ "Turno: " + marker.turno }}
                  </div>
                  <div class="dialog">
                    {{ "Hora de llegada: " + marker.hora_llegada }}
                  </div>
                </gmap-info-window>
              </gmap-marker>
            </div>
          </GmapCluster>
        </div>
        <gmap-polyline
          v-for="(p, i) in lineColor"
          :key="p.key"
          v-bind:path="lineColor[i].path"
          v-bind:options="{
            strokeColor: lineColor[i].color,
            strokeOpacity: lineColor[i].opacityLine,
          }"
        />
      </gmap-map>

      <div id="searchClients" style="margin-left: 10px">
        <v-card style="margin-top: 10px" max-width="400">
          <v-row no-gutters dense class="ps-2 pe-2">
            <v-col cols="8" sm="8" md="8">
              <v-autocomplete
                v-model="clientSearch"
                :items="clientItem"
                label="Clientes"
                prepend-icon="mdi-account-group"
                @change="consult()"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="4"
              sm="4"
              md="4"
              class="d-flex align-self-center justify-center"
            >
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!clientSearch"
                dense
                color="pinkKonect"
                class="mx-2"
                elevation="0"
                @click="consult()"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div id="updateInfo">
        <v-progress-circular v-if="loading" indeterminate color="primary" />
        <span v-if="!loading" class="caption"
          >Ultima actualizacion: {{ lastUpdate }}
        </span>
        <v-tooltip top v-if="!loading">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="blueKonect" dark v-bind="attrs" v-on="on"
              >mdi-alert-circle-outline</v-icon
            >
          </template>
          <span>La actualizacion es automatica</span>
        </v-tooltip>
      </div>
      <div
        id="busses"
        style="
          margin-left: 10px;
          margin-inline-end: 0px;
          position: absolute;
          top: 80px;
          left: 0px;
        "
      >
        <v-card
          max-width="350"
          style="margin-top: 10px; height: 100%"
          v-if="clientSearch"
        >
          <v-card-title>
            <span class="headline">Rutas</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="viewDetails()" text>{{
              messageDetail
            }}</v-btn>
          </v-card-title>
          <div v-if="viewDetail == 0">
            <v-btn color="primary" @click="hidden()" text>Ocultar</v-btn>
            <v-btn color="primary" @click="noHidden()" text>Mostrar</v-btn>
            <v-card-text style="max-height: 300px" class="scroll">
              <div v-for="(cData, n) in clientsData" :key="cData.key">
                {{ clientsData[n].name }}
                <div v-for="(p, i) in clientsData[n].detail" :key="p.key">
                  <v-btn
                    v-if="clientsData[n].detail[i].info == true"
                    icon
                    color="pinkKonect"
                    @click="viewUnit(clientsData[n].detail[i])"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="clientsData[n].detail[i].info == false"
                    icon
                    color="blueKonect"
                    @click="viewUnit(clientsData[n].detail[i])"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                  <v-btn icon @click="entryOpacity(clientsData[n].detail[i])">
                    <v-icon
                      v-if="clientsData[n].detail[i].visible == true"
                      :color="clientsData[n].detail[i].color"
                      >mdi-car</v-icon
                    >
                    <v-icon v-if="clientsData[n].detail[i].visible == false"
                      >mdi-car-off</v-icon
                    >
                  </v-btn>
                  {{ clientsData[n].detail[i].idruta }}
                  {{ clientsData[n].detail[i].name }}
                </div>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </div>
      <div
        id="buss"
        v-show="rutaVisible != null"
        style="
          margin-left: 10px;
          margin-inline-end: 0px;
          position: absolute;
          top: 80px;
          margin-right: 10px;
          bottom: 0;
          margin-bottom: 30px;
        "
      >
        <v-card
          max-width="350"
          style="margin-top: 10px"
          v-if="rutaVisible != null"
        >
          <v-card-title
            style="display: flex; justify-content: center"
            class="pb-0"
          >
            <span style="font-weight: 700; font-size: 16px"
              >Información de ruta seleccionada</span
            >
            <span style="font-weight: 400; font-size: 14px; margin-top: -5px"
              >Unidad en movimiento: {{ rutaVisible.bus }}</span
            >
          </v-card-title>
          <div
            style="display: flex; align-items: center"
            class="container py-0"
          >
            <div class="d-flex mx-2">
              <v-icon color="primary" large>mdi-bus</v-icon>
            </div>
            <div style="display: flex; flex-direction: column" class="mr-2">
              <span style="font-weight: 700; font-size: 16px"
                >Información de ruta</span
              >
              <span style="font-weight: 400; font-size: 12px"
                >Nombre: {{ rutaVisible.name }}</span
              >
              <span style="font-weight: 400; font-size: 13px"
                >Servicio: {{ rutaVisible.type }}</span
              >
              <span
                style="font-weight: 400; font-size: 13px"
                v-if="rutaVisible.bus"
                >Unidad en movimiento: {{ rutaVisible.bus }}</span
              >
            </div>
            <div class="d-flex">
              <v-btn color="primary" @click="centerMap()">Centrar</v-btn>
            </div>
          </div>
          <div
            class="container pb-0"
            style="display: flex; align-items: center"
          >
            <div class="d-flex mx-3">
              <v-icon color="#e22e86" large>mdi-map-marker</v-icon>
            </div>
            <div style="display: flex; flex-direction: column" class="mr-4">
              <span style="font-weight: 700; font-size: 16px"
                >Información de paradas</span
              >
            </div>
          </div>
          <div
            style="overflow-y: scroll; scroll-behavior: smooth; height: 100%"
          >
            <div
              class="container"
              style="
                display: flex;
                align-items: center;
                padding-bottom: 5px;
                padding-left: 15px;
                text-wrap: nowrap;
              "
              v-for="(p, i) in rutaVisible.paradas"
            >
              <div style="display: flex; flex-direction: column" class="mr-4">
                <span style="font-weight: 500; font-size: 14px">{{
                  p.orden +
                  " - T" +
                  p.turnos[0].turno_id +
                  " - " +
                  (p.turnos.length > 0 ? p.turnos[0].hora_llegada : "") +
                  " - " +
                  p.nombre_parada
                }}</span>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar
      v-model="error"
      color="error"
      :timeout="2500"
      bottom
      right
      style="white-space: pre-line"
    >
      {{ errorList[codeError] }}
      {{ "\n\n" + this.codeError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import { to12HoursFormat, errorList } from "../../utils";

export default {
  name: "Maps",
  data: () => ({
    routes: [
      {
        text: "Inicio",
        disabled: false,
        href: "Home",
        icon: "mdi-home",
        color: "blueKonect",
      },
      {
        text: "Mapas",
        disabled: false,
        href: "mapaClientes",
        icon: "mdi-map",
        color: "blueKonect",
      },
      {
        text: "Mapas de clientes",
        disabled: true,
        href: "mapaClientes",
        icon: "mdi-map-search",
      },
    ],
    errorList,
    rutaVisible: null,
    items: [],
    lineColor: [],
    simbolos: "0123456789ABCDEF",
    newColor: "",
    itemsAux: [],
    locationBus: [],
    infoTravel: "",
    stopsData: false,
    dataLine: [],
    clientsData: [],
    vehiclesDisabled: [],
    loading: false,
    success: false,
    msgSuccess: "",
    visibleVe: true,
    error: false,
    msgError: "",
    codeError: "",
    viewDetail: 1,
    messageDetail: "Ver",
    center: {
      lat: 25.689665,
      lng: -100.310619,
    },
    option: {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
    },
    zoom: 13,
    window_open: false,
    icon: { url: require("@/assets/marker.png") },
    bus: { url: require("@/assets/bus.png"), scaledSize: null },
    locate: null,
    clientItem: [],
    clientSearch: "",
    timeCoor: 0,
    lastUpdate: moment().format("h:mm:ss a"),
    markers: [],
    vehicles: [],
    path: [],
    path2: [],
    aux: [],
    coorAux: [],
    colors: [
      "#ff00e6",
      "#ff0000",
      "#00a600",
      "#004cff",
      "#ff8400",
      "#3c00ff",
      "#0077ff",
      "#ff00a6",
      "#000",
    ],
  }),
  computed: {
    google: gmapApi,
  },
  mounted() {
    if (true) {
      this.$refs.gmap.$mapPromise.then((map) => {
        var searchClients = document.getElementById("searchClients");
        searchClients.index = 1; // Esto es importante sino arroja error.
        map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(
          searchClients
        );

        var updateInfo = document.getElementById("updateInfo");
        updateInfo.index = 1; // Esto es importante sino arroja error.
        map.controls[this.google.maps.ControlPosition.BOTTOM_CENTER].push(
          updateInfo
        );

        var busses = document.getElementById("busses");
        busses.index = 1; // Esto es importante sino arroja error.
        map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(busses);

        var buss = document.getElementById("buss");
        buss.index = 1; // Esto es importante sino arroja error.
        map.controls[this.google.maps.ControlPosition.RIGHT_TOP].push(buss);
      });

      this.$gmapApiPromiseLazy().then(() => {
        this.bus.scaledSize = new this.google.maps.Size(50, 50);
      });
      this.refresh();
    } else {
      this.$router.push("/client/reporteUsuarios");
    }
  },
  destroyed() {
    clearInterval(this.locate);
  },
  methods: {
    centerMap() {
      var primeraParada = this.rutaVisible.paradas[0].coordenadas;
      var ultimaParada =
        this.rutaVisible.paradas[this.rutaVisible.paradas.length - 1]
          .coordenadas;

      var latitud_media =
        (primeraParada.coordinates[1] + ultimaParada.coordinates[1]) / 2;
      var longitud_media =
        (primeraParada.coordinates[0] + ultimaParada.coordinates[0]) / 2;

      this.center = {
        lat: latitud_media,
        lng: longitud_media,
      };
    },
    refresh() {
      this.loading = true;
      services
        .ws("get", "clients")
        .then((res) => {
          this.itemsAux = res.data;
          for (let i = 0; i < this.itemsAux.length; i++) {
            this.clientItem.push({
              text: this.itemsAux[i].nombre_comercial,
              value: this.itemsAux[i].idcliente_externo,
            });
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewDetails() {
      if (this.viewDetail == 1) {
        this.viewDetail = 0;
        this.messageDetail = "Ocultar";
      } else {
        this.viewDetail = 1;
        this.messageDetail = "Ver";
      }
    },
    viewUnit(view) {
      if (view.info == true) {
        view.info = false;
      } else {
        view.info = true;
      }
    },
    rotateImageVehicle() {
      let data = require("@/assets/busMarker.png");
      return {
        url: data,
      };
    },
    openWindow(open) {
      open.dialog = true;
    },
    closeWindow(close) {
      close.dialog = false;
    },
    entryOpacity(color) {
      this.rutaVisible = null;
      if (color.visible == true) {
        color.visible = false;
        for (let i = 0; i < this.lineColor.length; i++) {
          if (color.idruta_externo == this.lineColor[i].idruta_externo) {
            this.lineColor[i].opacityLine = 0;
          }
        }
        for (let i = 0; i < this.markers.length; i++) {
          if (color.idruta_externo == this.markers[i].idruta_externo) {
            this.markers[i].visible = false;
          }
        }
        for (let i = 0; i < this.vehicles.length; i++) {
          if (color.idruta_externo == this.vehicles[i].idruta_externo) {
            this.vehicles[i].visible = false;
          }
        }
      } else {
        color.visible = true;
        for (let i = 0; i < this.lineColor.length; i++) {
          if (color.idruta_externo == this.lineColor[i].idruta_externo) {
            this.lineColor[i].opacityLine = 1;
          }
        }
        for (let i = 0; i < this.markers.length; i++) {
          if (color.idruta_externo == this.markers[i].idruta_externo) {
            this.markers[i].visible = true;
          }
        }
        for (let i = 0; i < this.vehicles.length; i++) {
          if (color.idruta_externo == this.vehicles[i].idruta_externo) {
            this.vehicles[i].visible = true;
          }
        }
      }

      const objetosVisibles = this.lineColor.filter(
        (objeto) => objeto.visible === true
      );

      let today =
        new Date().getMonth() +
        1 +
        "-" +
        new Date().getDate() +
        "-" +
        new Date().getFullYear() +
        " ";
      if (objetosVisibles.length === 1) {
        this.rutaVisible = objetosVisibles[0];
        var idruta_externo_array1 = this.rutaVisible.idruta_externo;

        // Verificar si existe al menos una coincidencia en array2
        for (var i = 0; i < this.locationBus.length; i++) {
          if (this.locationBus[i].idruta_externo === idruta_externo_array1) {
            this.rutaVisible.bus = this.locationBus[i].numero_economico;
          }
        }
        this.rutaVisible.paradas.sort((a, b) => a.orden - b.orden);
        /*this.rutaVisible.paradas.forEach(objeto => {
          objeto.turnos.forEach(turno => {
            turno.hora_llegada = moment(today + turno.hora_llegada  + " UTC").format("HH:mm")
          });
        });*/
      }
    },
    hidden() {
      for (let i = 0; i < this.lineColor.length; i++) {
        this.lineColor[i].opacityLine = 0;
        this.lineColor[i].visible = false;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].visible = false;
      }
      // for (let i = 0; i < this.vehicles.length; i++) {
      //   this.vehicles[i].visible = false;
      // }
    },
    noHidden() {
      for (let i = 0; i < this.lineColor.length; i++) {
        this.lineColor[i].opacityLine = 1;
        this.lineColor[i].visible = true;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].visible = true;
      }
      for (let i = 0; i < this.vehicles.length; i++) {
        this.vehicles[i].visible = true;
      }
    },
    outOpacity() {
      for (let i = 0; i < this.lineColor.length; i++) {
        this.lineColor[i].opacityLine = 1;
      }
    },
    consult() {
      if (this.clientSearch) {
        this.rutaVisible = null;
        this.newLine = 0;
        this.loading = true;
        this.path = [];
        this.path2 = [];
        this.coorAux = [];
        this.lineColor = [];
        this.markers = [];
        this.vehicles = [];
        this.clientsData = [];
        let data = {
          idcliente_externo: this.clientSearch,
        };
        let today =
          new Date().getMonth() +
          1 +
          "-" +
          new Date().getDate() +
          "-" +
          new Date().getFullYear() +
          " ";
        this.axios
          .post(services.routes.maps + "/van", { data })
          .then((res) => {
            this.items = res.data.data;

            this.items.forEach((item) => {
              item.cliente.forEach((cliente) => {
                if (this.clientSearch === cliente.cliente.idcliente_externo) {
                  this.path = [];

                  cliente.cliente.rutas.forEach((ruta) => {
                    const color = this.colors[this.getRandomInt(9)];
                    const rutaData = {
                      idruta: ruta.idruta,
                      idruta_externo: ruta.idruta_externo,
                      color: color,
                      opacityLine: 1,
                      client: cliente.cliente.nombre_comercial,
                      name: ruta.nombre_ruta,
                      info: false,
                      visible: true,
                      path: [],
                      paradas: ruta.paradas,
                      type: ruta.tipo_servicio,
                    };

                    // Procesar las coordenadas de la ruta
                    const path2 = ruta.georuta.coordinates.map(
                      (coordinate) => ({
                        lat: coordinate[1],
                        lng: coordinate[0],
                        color: color,
                      })
                    );

                    // Asignar el path y guardarlo
                    rutaData.path = path2;
                    this.path.push(path2);
                    this.lineColor.push(rutaData);

                    // Procesar las paradas
                    ruta.paradas.forEach((parada) => {
                      const turno = parada.turnos[0];
                      if (!turno) {
                        return;
                      }
                      parada.turnos[0].hora_llegada_original =
                        turno.hora_llegada;
                      parada.turnos[0].hora_llegada = to12HoursFormat(
                        turno.hora_llegada,
                        true
                      );

                      this.markers.push({
                        idruta_externo: ruta.idruta_externo,
                        visible: true,
                        routeName: ruta.nombre_ruta,
                        stopName: parada.nombre_parada,
                        turno: turno.turno_id,
                        hora_llegada: turno.hora_llegada,
                        dialog: false,
                        coor: {
                          lat: parada.coordenadas
                            ? parada.coordenadas.coordinates[1]
                            : 0,
                          lng: parada.coordenadas
                            ? parada.coordenadas.coordinates[0]
                            : 0,
                        },
                      });
                    });
                  });

                  // Ordenar rutas por nombre
                  this.lineColor.sort((a, b) => a.name.localeCompare(b.name));

                  // Agrupar los datos de los clientes
                  const clienteDataMete = {
                    name: `${cliente.cliente.nombre_comercial} - Mete`,
                    detail: this.lineColor.filter((line) => line.type === "M"),
                  };
                  const clienteDataSaca = {
                    name: `${cliente.cliente.nombre_comercial} - Saca`,
                    detail: this.lineColor.filter((line) => line.type !== "M"),
                  };

                  this.clientsData.push(clienteDataMete, clienteDataSaca);
                }
              });
            });

            this.success = true;
            this.msgSuccess = "Rutas obtenidas con éxito";
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response?.data?.code || "Error general";
          })
          .finally(() => {
            this.updateVehicle();
            this.timeData();
            this.loading = false;
          });
      }
    },
    timeData() {
      this.locate = setInterval(() => {
        this.updateVehicle();
      }, 90000);
    },
    updateVehicle() {
      let data = {
        idcliente_externo: this.clientSearch,
      };
      this.loading = true;
      this.axios
        .post(services.routes.tracking + "/van", { data })
        .then((res) => {
          for (let i = 0; i < this.vehicles.length; i++) {
            if (this.vehicles[i].visible == false) {
              this.vehiclesDisabled.push(this.vehicles[i].idruta_externo);
            }
          }
          this.vehicles = [];
          this.locationBus = res.data.data;
          for (let i = 0; i < this.locationBus.length; i++) {
            this.visibleVe = true;
            for (let j = 0; j < this.vehiclesDisabled.length; j++) {
              if (
                this.vehiclesDisabled[j] == this.locationBus[i].idruta_externo
              ) {
                this.visibleVe = false;
              }
            }

            this.vehicles.push({
              noVehicle: this.locationBus[i].numero_economico,
              tipo_servicio: this.locationBus[i].tipo_servicio,
              turno_id: this.locationBus[i].turno_id,
              dialog: false,
              angule: this.locationBus[i].direccion,
              visible: this.visibleVe,
              idruta_externo: this.locationBus[i].idruta_externo,
              service: this.locationBus[i].tipo_servicio,
              coor: {
                lat: this.locationBus[i].posicion.coordinates[1],
                lng: this.locationBus[i].posicion.coordinates[0],
              },
            });
          }
          this.vehiclesDisabled = [];
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.lastUpdate = moment().format("h:mm:ss a");
        });
      this.loading = false;
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
  },
};
</script>

<style scoped>
.vehicleModal {
  align-content: center !important;
}
.scroll {
  overflow-y: scroll !important;
}
</style>
